import { formatFipeZapValuationLabel } from "../utils/formatFipeZapValuationLabel";

export const FIPE_ZAP_VALUATION_TOOLTIP_TITLE = "Como é calculado";

export const FIPE_ZAP_VALUATION_INFO_LABEL =
  "Como a valorização FIPE Zap é estimada";

export function getFipeZapValuationTooltipDescription(
  city: string | null | undefined
): string {
  return formatFipeZapValuationLabel(city);
}
